import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../assets/styles/FormComponent.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { jwtDecode } from 'jwt-decode';
import Sidebar from '../components/Sidebar';
import { useNavigate } from 'react-router-dom';

const initialQuestions = [
  {
    questionText: 'What basic features does the product or service offered by your initiative respond to?',
    answers: [
      { answerText: 'Basic need oriented' },
      { answerText: 'Problem solving focused' },
      { answerText: 'Social oriented'},
      { answerText: 'Two of these'},
      { answerText: 'None of these'},
    ],
  },
  {
    questionText: 'Which basic strategy do you follow to become a sustainable enterprise?',
   
    answers: [
      { answerText: 'Differencing' },
      { answerText: 'Competitive Advantage' },
      { answerText: 'Innovation and operational efficiency' },
    ],
  },
  {
    questionText: 'Is your solution to the market global or local?',
   
    answers: [
      { answerText: 'Global' },
      { answerText: 'Local' },
    ],
  },
  {
    questionText: 'Is your startup capitalizing on an existing trend?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'Have you done PESTLE Analysis to verify the timing of your initiative?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'At what stage is your product or service currently?',
   
    answers: [
      { answerText: 'Prototype stage' },
      { answerText: 'MVP stage' },
      { answerText: 'Sales-service stage' },
    ],
  },
  {
    questionText: 'Have you pivoted?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'How many times did you pivot?',
   
    answers: [
      { answerText: '0' },
      { answerText: '1-2' },
      { answerText: '3-more' },
    ],
  },
  {
    questionText: 'Which is your product or service closer to?',
   
    answers: [
      { answerText: 'Not developing technology' },
      { answerText: 'Outsourced technology' },
      { answerText: 'Technology develop' },
    ],
  },
  {
    questionText: 'Is there any entrepreneurship experience among the founding partners?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'Is there any corporate experience among the founding partners?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'How often does the team work together?',
   
    answers: [
      { answerText: '1 per week' },
      { answerText: '2-3 per week' },
      { answerText: 'Every day' },
    ],
  },
  {
    questionText: 'What personas do you have on your founding team?',
   
    answers: [
      { answerText: 'Only one' },
      { answerText: 'Hipster-hacker-hustler' },
      { answerText: 'Only two' },
    ],
  },
  {
    questionText: 'Did the founding members know each other before?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'Do the founders have experience in the field in which the startup operates?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'Who is involved in the solution when a problem is encountered during the development process?',
   
    answers: [
      { answerText: 'Co-Founders' },
      { answerText: 'Team' },
    ],
  },
  {
    questionText: 'How many potential customers have you talked to about your startup idea?',
   
    answers: [
      { answerText: '0' },
      { answerText: '15-30' },
      { answerText: '30+' },
    ],
  },
  {
    questionText: 'Do you have written collaborations? For example, Sponsors:',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'Do you have a mentor you are in constant contact with?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'Have you received feedback from investors?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No', weight: 0 },
    ],
  },
  {
    questionText: 'What is the market place of your product or service?',
   
    answers: [
      { answerText: 'A new concept' },
      { answerText: 'New additions to existing product range' },
      { answerText: 'Changes in existing product' },
    ],
  },
  {
    questionText: 'Have you made your first sale?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'Have you made promotions-campaigns for your startup?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'Have you set up a community where you share your initiative with users?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'Have you been on the platforms that make startup news? For example, Webrazzi, ProductHunt, Hackernews, etc.',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
    ],
  },
  {
    questionText: 'How many channels do you actively use in your venture? For example Guerrilla marketing, mail marketing, social media marketing',
   
    answers: [
      { answerText: '0' },
      { answerText: '1-3' },
      { answerText: '3+' },
    ],
  },

  {
    questionText: 'How much has your potential users increased compared to the previous month?',
   
    answers: [
      { answerText: 'Less than 30%' },
      { answerText: 'More than 30%' },
      { answerText: 'Uncertain' },
    ],
  },
  
  {
    questionText: 'Is your company VC-backed?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
      
    ],
  },
  {
    questionText: 'Do you use Stripe/Paypal?',
   
    answers: [
      { answerText: 'Yes' },
      { answerText: 'No' },
      
    ],
  },
  {
    questionText: 'For how many years/ months has your company been receiving invoices/payments?',
   
    answers: [
      { answerText: 'Within the first 6 months' },
      { answerText: 'Between 6-12 months' },
      { answerText: 'Between 1-2 years' },
      { answerText: 'Between 2-3 years' },
      { answerText: 'After 3 years' },
      
    ],
  },
  {
    questionText: 'For how long has your company been receiving invoices/payments after your latest pivot?',
   
    answers: [
      { answerText: 'Before making the pivot' },
      { answerText: 'After the first pivot' },
      { answerText: 'After the second pivot' },
      { answerText: 'After the third pivot' },
      { answerText: 'After the fourth or subsequent pivots' },
    ],
  },
];

const FormComponent = () => {
  const [questions, setQuestions] = useState(initialQuestions);
  const [response, setResponse] = useState(null);
  const [analyticsLink, setAnalyticsLink] = useState(null);
  const [showDescription, setShowDescription] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  const handleQuestionChange = (index, e) => {
    const newQuestions = [...questions];
    newQuestions[index][e.target.name] = e.target.value;
    setQuestions(newQuestions);
  };

  const handleAnswerChange = (qIndex, aIndex, e) => {
    const newQuestions = [...questions];
    newQuestions[qIndex].answers[aIndex][e.target.name] = e.target.value;
    setQuestions(newQuestions);
  };

  const handleAddQuestion = () => {
    // Add the new question
    setQuestions([
      ...questions, 
      { 
        questionText: '', 
        weight: '3', // Default weight
        answers: [{ answerText: '', weight: '3' }] 
      }
    ]);
    
    // Scroll to the new question after it's added to the DOM
    setTimeout(() => {
      const questionBlocks = document.querySelectorAll('.question-block');
      if (questionBlocks.length > 0) {
        const newQuestionBlock = questionBlocks[questionBlocks.length - 1];
        newQuestionBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  const handleClearAllQuestions = () => {
    if (window.confirm('Are you sure you want to clear all questions?')) {
      setQuestions([]);
    }
  };

  const handleAddAnswer = (qIndex) => {
    const newQuestions = [...questions];
    newQuestions[qIndex].answers.push({ answerText: '', weight: '3' });
    setQuestions(newQuestions);
    
    // Scroll to the new answer after it's added to the DOM
    setTimeout(() => {
      const answerBlocks = document.querySelectorAll(`.question-block:nth-child(${qIndex + 1}) .answer-row`);
      if (answerBlocks.length > 0) {
        const newAnswerBlock = answerBlocks[answerBlocks.length - 1];
        newAnswerBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  const handleDeleteQuestion = (qIndex) => {
    const newQuestions = questions.filter((_, index) => index !== qIndex);
    setQuestions(newQuestions);
  };

  const handleDeleteAnswer = (qIndex, aIndex) => {
    const newQuestions = [...questions];
    // Don't allow deleting if it's the last answer
    if (newQuestions[qIndex].answers.length > 1) {
      newQuestions[qIndex].answers = newQuestions[qIndex].answers.filter((_, index) => index !== aIndex);
      setQuestions(newQuestions);
    } else {
      alert("Each question must have at least one answer.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (questions.length === 0) {
      alert("Please add at least one question.");
      return;
    }
    
    // Check if all questions have at least one answer
    const invalidQuestions = questions.findIndex(q => q.answers.length === 0);
    if (invalidQuestions >= 0) {
      alert(`Question ${invalidQuestions + 1} has no answers. Please add at least one answer.`);
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Fetch form submission response
      const res = await axios.post('https://api.startupdriver.co/api/forms', { questions });
      
      const formId = res.data.formId;
      const formLink = `https://investor.startupdriver.co/form/${formId}`;
      const analyticsLink = `https://investor.startupdriver.co/analytics/${formId}`;
      
      // Set response links for frontend display
      setResponse(formLink);
      setAnalyticsLink(analyticsLink);
  
      // Automatically get the userId from the JWT token stored in localStorage
      const token = localStorage.getItem('token');
      if (token) {
        const decodedToken = jwtDecode(token);
        const userId = decodedToken.userId;
  
        // Save the form and analytics links to the backend, tied to the userId
        await axios.post('https://api.startupdriver.co/api/links/saveLinks', {
          formLink,
          analyticsLink,
          userId,
        });
      } else {
        console.error('No token found. User is not authenticated.');
      }
      
      // Scroll to response message
      setTimeout(() => {
        const responseElement = document.querySelector('.response-message');
        if (responseElement) {
          responseElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred while submitting the form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="main-page">
      <Sidebar />
      <div className="content">
        <div className="form-container">
          <div className="form-header">
            <div className="link-head-container">
              <h2 className="link-head">Create Form</h2>
              <div
                className="info-icon"
                onClick={() => setShowDescription(!showDescription)}
                title={showDescription ? "Hide Information" : "Show Information"}
              >
                <i className="fas fa-info"></i>
              </div>
            </div>
            
            <div className="page-description-container">
              <div className={`page-description ${showDescription ? "open" : "closed"}`}>
                <div className="description-text">
                  <i className="fas fa-lightbulb" style={{ color: '#abe147', marginRight: '5px' }}></i> 
                  You can edit this form according to your own parameters, the questions you will ask, and add your own weights according to the degree of importance.
                  <br /><br />
                  <i className="fas fa-lightbulb" style={{ color: '#abe147', marginRight: '5px' }}></i> 
                  Below are sample questions and answers for the evaluation of an initiative. You can also use this form or make changes to it if you wish.
                </div>
              </div>
            </div>
          </div>

          <button 
            type="button"
            className="clear-all-button"
            onClick={handleClearAllQuestions}
          >
            <i className="fas fa-trash-alt"></i> Clear All
          </button>
          
          <form onSubmit={handleSubmit}>
            {questions.length > 0 ? (
              questions.map((question, qIndex) => (
                <div key={qIndex} className="question-block">
                  <div className="question-header">
                    <input
                      type="text"
                      name="questionText"
                      value={question.questionText}
                      onChange={(e) => handleQuestionChange(qIndex, e)}
                      placeholder="Enter your question"
                      className="question-input"
                      required
                    />
                    <input
                      type="number"
                      name="weight"
                      value={question.weight}
                      onChange={(e) => handleQuestionChange(qIndex, e)}
                      min="1"
                      max="5"
                      placeholder="Weight (1-5)"
                      className="weight-input"
                      required
                    />
                  </div>
                  
                  <div className="answers-block">
                    {question.answers.map((answer, aIndex) => (
                      <div key={aIndex} className="answer-row">
                        <input
                          type="text"
                          name="answerText"
                          value={answer.answerText}
                          onChange={(e) => handleAnswerChange(qIndex, aIndex, e)}
                          placeholder="Enter an answer option"
                          className="answer-input"
                          required
                        />
                        <input
                          type="number"
                          name="weight"
                          value={answer.weight}
                          onChange={(e) => handleAnswerChange(qIndex, aIndex, e)}
                          min="1"
                          max="5"
                          placeholder="Weight (1-5)"
                          className="weight-input"
                          required
                        />
                        <button
                          type="button"
                          className="delete-button action-button"
                          onClick={() => handleDeleteAnswer(qIndex, aIndex)}
                          title="Delete Answer"
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                  
                  <div className="question-footer">
                    <button
                      type="button"
                      className="add-button action-button"
                      onClick={() => handleAddAnswer(qIndex)}
                      title="Add Answer"
                    >
                      <i className="fas fa-plus"></i> Add Answer
                    </button>
                    <button
                      type="button"
                      className="delete-button action-button"
                      onClick={() => handleDeleteQuestion(qIndex)}
                      title="Delete Question"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-form-message">
                <p>No questions added yet. Click "Add Question" to start building your form.</p>
              </div>
            )}
            
            <div className="form-actions">
              <button
                type="button"
                className="add-question-button action-button"
                onClick={handleAddQuestion}
              >
                <i className="fas fa-plus"></i> Add Question
              </button>
              <button 
                type="submit" 
                className="submit-button action-button"
                disabled={isSubmitting || questions.length === 0}
              >
                {isSubmitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Submitting...
                  </>
                ) : (
                  <>
                    <i className="fas fa-check"></i> Submit Form
                  </>
                )}
              </button>
            </div>
          </form>

          {response && (
            <div className="response-message">
              <p><i className="fas fa-check-circle" style={{ color: '#6b8a2a', marginRight: '5px' }}></i> <strong>Form submitted successfully!</strong></p>
              <p>Your form and analytics page links have been created. You can find them in the "Access Your Links" section on the sidebar.</p>
              <p><strong>Form Link:</strong> <a href={response} target="_blank" rel="noopener noreferrer">{response}</a></p>
              <p><strong>Analytics Link:</strong> <a href={analyticsLink} target="_blank" rel="noopener noreferrer">{analyticsLink}</a></p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormComponent;